<template>
    <div
        id="sezioni"
        v-bind:class="[showAuthPopup ? 'bg-light popup-aperto' : 'bg-light']"
    >
        <vue-headful :title="pageTitle" />
        <loading-animation
            class="loading"
            style="position:absolute;top:50%;left:50%;"
            v-if="loading"
        ></loading-animation>
        <div
            v-else
            class="body-wrapper"
        >
            <gallery-header />

            <main>
                <div class="container-fluid mt-5">
                    <h2 class="titolo-album text-center text-uppercase mb-0">
                        {{ title }}
                    </h2>
                    <h6
                        v-if="showCustomized"
                        class="text-center text-uppercase"
                    >{{ $t('Prodotti Personalizzati') }}</h6>
                </div>

                <div class="visualizzazione-sezioni">
                    <div class="container-fluid">
                        <!-- gallery prodotti personalizzati dell'utente -->
                        <div
                            v-if="showCustomized"
                            class="elenco-sezioni row"
                        >
                            <div
                                class="sezione text-center mt-5 col-sm-6 col-md-4 col-lg-3"
                                v-for="item in customizedEventItems"
                                :key="item.id"
                            >
                                <a
                                    href="javascript:void(0)"
                                    @click.prevent="onProjectClicked(item)"
                                    v-if="item.type === 'project'"
                                >
                                    <div
                                        class="img-container mw-100"
                                        :style="{'background-image': 'url(' + getProjectUrl(item.coverPhotoId) + ')'}"
                                    />
                                    <div class="bg-white p-2 d-flex justify-content-between align-items-center">
                                        <h3 class="mb-0 h5 font-corsivo-rikorda">
                                            {{item.title}}
                                        </h3>

                                        <b-button
                                            class="btn-rikorda1 flex-shrink-0"
                                            @click.stop.prevent="addProjectToCart(item)"
                                            v-show="!item.inCart && orderable"
                                        >
                                            <span class="mr-2">{{ parseFloat(item.price) | toCurrency }}</span>
                                            <font-awesome-icon :icon="['fas', 'shopping-cart']" />
                                        </b-button>

                                        <p
                                            class="mb-0 text-blurikorda"
                                            style="margin: 1px 0; padding: 0.375rem;"
                                            v-show="item.inCart && orderable"
                                        >
                                            <span class="mr-2">{{ parseFloat(item.price) | toCurrency }}</span>
                                            <font-awesome-icon :icon="['fas', 'shopping-cart']" />
                                        </p>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <!-- gallery standard -->
                        <div
                            v-else
                            class="elenco-sezioni row"
                        >
                            <div
                                class="sezione text-center mt-5 col-sm-6 col-md-4 col-lg-3"
                                v-for="item in eventItems"
                                :key="item.id"
                            >
                                <!-- gallery album -->
                                <a
                                    href="javascript:void(0)"
                                    @click.prevent="onGalleryClicked(item)"
                                    v-if="item.type === 'album'"
                                >
                                    <div
                                        class="img-container mw-100"
                                        :style="{'background-image': 'url(' + getUrl(item.coverPhotoId) + ')'}"
                                    />
                                    <div class="bg-white p-2 d-flex justify-content-between align-items-center">
                                        <h3 class="mb-0 h5 font-corsivo-rikorda">
                                            {{ $t("Galleria") }}
                                        </h3>
                                        <p
                                            class="mb-0"
                                            style="margin: 1px 0; padding: 0.375rem;"
                                        >
                                            {{ item.numPhotos }} {{ $t("foto") }}
                                        </p>
                                    </div>
                                </a>

                                <!-- project -->
                                <a
                                    href="javascript:void(0)"
                                    @click.prevent="onProjectClicked(item)"
                                    v-if="item.type === 'project'"
                                >
                                    <div
                                        class="img-container mw-100"
                                        :style="{'background-image': 'url(' + getProjectUrl(item.coverPhotoId) + ')'}"
                                    />
                                    <div class="bg-white p-2 d-flex justify-content-between align-items-center">
                                        <h3 class="mb-0 h5 font-corsivo-rikorda">
                                            {{item.title}}
                                        </h3>

                                        <b-button
                                            class="btn-rikorda1 flex-shrink-0"
                                            @click.stop.prevent="addProjectToCart(item)"
                                            v-show="!item.inCart && orderable"
                                        >
                                            <span class="mr-2">{{ parseFloat(item.price) | toCurrency }}</span>
                                            <font-awesome-icon :icon="['fas', 'shopping-cart']" />
                                        </b-button>

                                        <p
                                            class="mb-0 text-blurikorda"
                                            style="margin: 1px 0; padding: 0.375rem;"
                                            v-show="item.inCart && orderable"
                                        >
                                            <span class="mr-2">{{ parseFloat(item.price) | toCurrency }}</span>
                                            <font-awesome-icon :icon="['fas', 'shopping-cart']" />
                                        </p>
                                    </div>
                                </a>

                                <!-- customizable product -->
                                <a
                                    href="javascript:void(0)"
                                    @click.prevent="editCustomizableProduct(item)"
                                    v-if="item.type === 'customizable'"
                                >
                                    <div
                                        class="img-container mw-100"
                                        :style="{'background-image': 'url(' + getCustomizableProductPreview(item.preview) + ')'}"
                                    />
                                    <div class="bg-white p-2 d-flex justify-content-between align-items-center">
                                        <h3 class="mb-0 h5 font-corsivo-rikorda">
                                            {{item.title}}
                                        </h3>

                                        <b-button
                                            class="btn-rikorda1 flex-shrink-0"
                                            @click.stop.prevent="editCustomizableProduct(item)"
                                            v-show="!item.inCart && orderable"
                                        >
                                            <span class="mr-2">{{ parseFloat(item.price) | toCurrency }}</span>
                                            <font-awesome-icon :icon="['fas', 'pencil-alt']" />
                                        </b-button>

                                        <p
                                            class="mb-0 text-blurikorda"
                                            style="margin: 1px 0; padding: 0.375rem;"
                                            v-show="item.inCart && orderable"
                                        >
                                            <span class="mr-2">{{ parseFloat(item.price) | toCurrency }}</span>
                                            <font-awesome-icon :icon="['fas', 'shopping-cart']" />
                                        </p>
                                    </div>
                                </a>
                            </div>
                        </div>

                        <div
                            v-if="hasCustomized"
                            class="pulsante-aggiungi-foto-container text-center"
                        >
                            <b-button
                                type="button"
                                class="btn btn-rikorda1 mt-3 w-75"
                                @click.stop.prevent="onSwitchViewMode()"
                            >
                                <div v-if="showCustomized">
                                    <font-awesome-icon :icon="['fa', 'inbox']" />
                                    <span class="ml-1">{{ $t('Galleria') }}</span>
                                </div>

                                <div v-else>
                                    <font-awesome-icon :icon="['fab', 'product-hunt']" />
                                    <span class="ml-1">{{ $t('Prodotti personalizzati') }}</span>
                                </div>
                            </b-button>
                        </div>
                    </div>
                </div>
            </main>

            <gallery-footer />
        </div>

        <!-- modale conferma aggiunta al carrello del progetto !-->
        <b-modal
            id="projectAddedToCartModal"
            hide-footer
        >
            <template #modal-header-close="{ close }">
                <b-button
                    class="d-inline-flex align-items-center btn-rikorda2-alt"
                    @click="close"
                >
                    <font-awesome-icon :icon="['fas', 'times']" />
                    <span class="d-none d-sm-inline ml-1 small font-weight-normal text-uppercase">
                        {{$t("Chiudi")}}
                    </span>
                </b-button>
            </template>
            <template #default="{ hide }">
                <div class="container-fluid flex-grow-1 mt-3 mb-3">
                    <div class="icon-addtocart-success text-center px-4 pt-2 pb-2 text-success">
                        <font-awesome-icon
                            :icon="['fas', 'check-circle']"
                            style="width: 3rem; height: 3rem;"
                        />
                    </div>

                    <h3 class="titolo-popup text-center text-uppercase px-4 pb-2 pt-2 mb-0">
                        {{ $t("L'articolo è stato aggiunto al carrello") }}
                    </h3>

                    <div class="text-center mt-4">
                        <button
                            class="btn btn-primary pulsante-carrello btn-rikorda1 btn-chevron-right"
                            @click="goToCart()"
                        >
                            {{ $t("Vai al carrello") }}
                            <font-awesome-icon :icon="['fas', 'chevron-right']" />
                        </button>
                    </div>

                    <div class="text-center mt-4">
                        <button
                            class="btn btn-outline-primary pulsante-continua-shopping btn-rikorda2 btn-chevron-right"
                            @click="hide"
                        >
                            {{ $t("Aggiungi altri articoli") }}
                            <font-awesome-icon :icon="['fas', 'chevron-right']" />
                        </button>
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
import GalleryHeader from "../../components/gallery/Header";
import GalleryFooter from "../../components/gallery/Footer";
import LoadingAnimation from "../../components/LoadingAnimation";

export default {
    name: "EventDashboard",

    components: { GalleryHeader, GalleryFooter, LoadingAnimation },

    data() {
        return {
            loading: true,
            eventId: "",
            pageTitle: null,
            title: null,
            orderable: true,
            author: null,
            numPhotos: 0,
            eventItems: [],
            customizedEventItems: [],
            showAuthPopup: false,
            loginUsername: ""
        };
    },

    mounted() {
        // recupero dati evento
        this.$store
            .dispatch("GET_EVENT_DATA_DASHBOARD")
            .then((result) => {
                console.debug("GET_EVENT_DATA_DASHBOARD", result);
                this.eventId = result.eventId;
                this.eventItems = result.eventItems;
                this.customizedEventItems = result.customizedEventItems;
                this.orderable = result.orderable;

                if (this.eventItems === null || this.eventItems.length == 0) {
                    alert(
                        "Attenzione: l'evento non è completo. Contatta il fotografo."
                    );
                    throw new Error("Evento attivo vuoto");
                }

                // redirect a gallery home in caso nell'evento ci sia solo il singolo album
                if (
                    this.eventItems.length == 1 &&
                    this.eventItems[0].type === "album"
                ) {
                    console.debug("Redirecting to album ... ");
                    this.$router.push({
                        name: "gallery-album",
                        params: {
                            galleryUrl: this.$route.params.galleryUrl,
                            albumId: this.eventItems[0].id
                        }
                    });
                }

                this.title = result.title;
                this.author = result.author;
                this.eventItems.forEach((gallery) => {
                    this.numPhotos += parseInt(gallery.numPhotos);
                });
                this.setPageTitle();
            })
            .catch((error) => {
                console.error("GET_EVENT_DATA_DASHBOARD", error);
                this.$router.push({
                    name: "gallery",
                    params: {
                        galleryUrl: this.$route.params.galleryUrl
                    }
                });
            })
            .finally(() => {
                this.loading = false;
            });
    },

    methods: {
        setPageTitle() {
            this.pageTitle = [
                this.title,
                this.$t("di"),
                this.author,
                "- Rikorda"
            ].join(" ");
        },

        onGalleryClicked(gallery) {
            switch (gallery.type) {
                case "album":
                    this.$router.push({
                        name: "gallery-album",
                        params: {
                            galleryUrl: this.$route.params.galleryUrl,
                            albumId: gallery.id
                        }
                    });
                    break;
                default:
                    console.warn(
                        "onGalleryClicked with unsupported type: ",
                        gallery.type
                    );
                    break;
            }
        },

        onProjectClicked(project) {
            console.debug("onProjectClicked");
            switch (project.type) {
                case "project":
                    this.$router.push({
                        name: "gallery-project",
                        params: {
                            galleryUrl: this.$route.params.galleryUrl,
                            projectId: project.id
                        }
                    });
                    break;
                default:
                    console.warn(
                        "onProjectClicked with unsupported type: ",
                        project.type
                    );
                    break;
            }
        },

        addProjectToCart(project) {
            console.debug("addProjectToCart");
            this.$store
                .dispatch("ADD_ITEM_TO_CART", {
                    photoId: project.id,
                    articleCode: project.articleCode,
                    quantity: 1,
                    projectId: project.id
                })
                .then((response) => {
                    this.$bvModal.show("projectAddedToCartModal");
                    for (var i = 0; i < this.eventItems.length; i++) {
                        if (this.eventItems[i].id === project.id) {
                            this.eventItems[i].inCart = true;
                            break;
                        }
                    }
                });
        },

        editCustomizableProduct(product) {
            console.debug("editCustomizableProduct");
            switch (product.type) {
                case "customizable":
                    this.$router.push({
                        name: "gallery-customizable-product",
                        params: {
                            galleryUrl: this.$route.params.galleryUrl,
                            albumId: this.eventItems[0].id,
                            productDataBase64: btoa(
                                JSON.stringify({
                                    productId: product.productId,
                                    themeUrl: product.themeUrl,
                                    numPhotos: product.numPhotos,
                                    title: product.title
                                })
                            )
                        }
                    });
                    break;
                default:
                    console.warn(
                        "editCustomizableProduct with unsupported type: ",
                        product.type
                    );
                    break;
            }
        },

        getUrl(photoId) {
            return this.$imagesService.getUrl(photoId, "event-web", true);
        },

        getProjectUrl(projectId) {
            return this.$imagesService.getProjectUrl(this.eventId, projectId);
        },

        getCustomizableProductPreview(preview) {
            if (preview) {
                if (preview.startsWith("/media/catalog/themes")) {
                    let url = new URL(process.env.VUE_APP_API_BASE_URL);
                    let hostname =
                        location.hostname === "localhost"
                            ? url.origin
                            : location.origin;
                    return encodeURI(hostname + preview);
                } else {
                    return "data:image/jpeg;base64," + preview;
                }
            }
            // image placeholder
            return "data:image/png;base64,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";
        },

        showLoginPopup() {
            this.showAuthPopup = !this.$store.getters.isUserDataValid;
            this.loginUsername = this.$store.getters.userState.email;
        },

        onUserLogin(user) {
            this.$store.dispatch("UPDATE_USER_DATA", this.loginUsername);
            this.showAuthPopup = false;
            this.isLoginRequired = false;
        },

        onUserLoginClose() {
            this.$router.push({
                name: "gallery-dashboard",
                params: this.$route.params
            });
        },

        goToCart: function () {
            this.$router.push({
                name: "gallery-cart",
                params: {
                    galleryUrl: this.$route.params.galleryUrl
                }
            });
        },

        onSwitchViewMode() {
            this.$router.push({
                name: this.showCustomized
                    ? "gallery-dashboard"
                    : "gallery-dashboard-customized",
                params: {
                    galleryUrl: this.$route.params.galleryUrl
                }
            });
        }
    },

    computed: {
        showCustomized() {
            return this.$route.name === "gallery-dashboard-customized";
        },

        hasCustomized() {
            return (
                this.customizedEventItems &&
                this.customizedEventItems.length > 0
            );
        }
    }
};
</script>

<style></style>
